import { Suspense, lazy } from 'react';
import LoadingScreen from 'src/componentes/LoadingScreen';

const Versoes = lazy(() => import('../EditPage/versionamento-manual'));

function VersoesTab({
  model,
  documentName,
  documentType,
  disableCreate,
  onVersionSaved,
}) {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Versoes
        documentName={model?.nome || documentName || ''}
        documentType={model?.tipoDocumento?.nome || documentType || ''}
        parameters={{
          documentoId: model?.id,
        }}
        disableCreate={disableCreate}
        onVersionSaved={onVersionSaved}
      />
    </Suspense>
  );
}

export default VersoesTab;
